import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-32 bg-white text-center px-4 sm:px-6 lg:px-8" data-id="element-42">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-4xl mx-auto" data-id="element-43">
        <h2 className="text-5xl md:text-7xl font-black mb-6 uppercase leading-[1.1]" data-id="element-44">
          Ready to Order <br className="hidden md:block" data-id="element-45" /> Custom Apparel?
        </h2>
        <p className="text-xl md:text-2xl text-gray-600 mb-10 font-medium" data-id="element-46">
          Get your free, fast quote — shirts, polos, hats, uniforms and more. No
          commitments.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-47">
          <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
          behavior: 'smooth'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full sm:w-auto bg-black text-white px-10 py-5 font-display font-black uppercase tracking-widest text-xl hover:bg-neutral-800 transition-colors" data-id="element-48">
            Get a Fast Quote
          </motion.button>
          <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
          behavior: 'smooth'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full sm:w-auto bg-white text-black border-4 border-black px-10 py-5 font-display font-black uppercase tracking-widest text-xl hover:bg-gray-50 transition-colors" data-id="element-49">
            Call or Message Now
          </motion.button>
        </div>
      </motion.div>
    </section>;
}